import { useTranslation } from "@i18n";
import { TiArrowBackOutline } from "react-icons/ti";
import { DASHBOARD_ROUTE } from "@Helpers/urlHelpers";
import useGoBack from "@Services/hooks/useGoBack";
import nodata from "../../assets/images/Forbidden.svg";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";

function Forbidden() {
  const { t } = useTranslation();
  const goBack = useGoBack();

  return (
    <div className="flex w-full flex-col items-center overflow-hidden">
      <div className="flex flex-col items-center justify-center text-center">
        <img src={nodata} alt="Forbidden 403" className="my-6 w-3/4" />
      </div>
      <div className="flex flex-col items-center justify-center">
        <span className="mb-2 text-2xl font-semibold text-[#7bd2fc]">{t("Sorry!")}</span>
        <span>{t("You do not have access to this page")}</span>
      </div>
      <ButtonComponent
        type="submit"
        buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        className="mt-4"
        onClick={() => goBack(DASHBOARD_ROUTE)}
      >
        <span className="flex items-center">
          <TiArrowBackOutline size={20} className="me-1" /> {t("Go back")}
        </span>
      </ButtonComponent>
    </div>
  );
}

export default Forbidden;
